import React from "../../../../__snowpack__/pkg/react.js";
import {Form, Input, InputNumber, Select, DatePicker, Radio} from "../../../../__snowpack__/pkg/antd.js";
import {InputLimit} from "../../../components/InputLimit.js";
const CustomItem = (props) => {
  const Comp = props.component;
  if (!Comp) {
    return /* @__PURE__ */ React.createElement("div", null, "\u81EA\u5B9A\u4E49\u8868\u5355\u9879\u9700\u8981\u63D0\u4F9B\u81EA\u5B9A\u4E49component");
  }
  return /* @__PURE__ */ React.createElement(Comp, {
    ...props
  });
};
const Text = (props) => /* @__PURE__ */ React.createElement("span", {
  className: "ant-form-text"
}, props.text || props.value);
const FormItem = Form.Item;
const {Search, TextArea} = Input;
const {MonthPicker, RangePicker} = DatePicker;
const RadioGroup = Radio.Group;
const formTypes = {
  Input,
  InputNumber,
  Select,
  Search,
  TextArea,
  DatePicker,
  MonthPicker,
  RangePicker,
  RadioGroup,
  CustomItem,
  Text,
  InputLimit
};
const ErrorComp = () => /* @__PURE__ */ React.createElement("div", null, "\u4E0D\u652F\u6301\u7684\u8868\u5355\u9879");
function renderFormItems(formItems, formProps) {
  formItems = Array.isArray(formItems) ? formItems : [formItems];
  return formItems.map((item, i) => {
    if (item.returnNull) {
      return null;
    }
    const Comp = formTypes[item.type] || ErrorComp;
    const props = item.props || {};
    let layout = Object.assign({}, formProps?.formItemLayout, item.formItemLayout);
    return /* @__PURE__ */ React.createElement(FormItem, {
      ...layout,
      ...item
    }, /* @__PURE__ */ React.createElement(Comp, {
      ...props
    }, item.children || null));
  });
}
export default renderFormItems;
